import type { WordDiffEntry } from '../text/normalize'

/** Speaking attempts: what the client sends and what it gets back. */

export interface SpeakingFeedback {
  /** What the transcriber heard. Shown verbatim — hiding it would be dishonest. */
  transcript: string
  /** Fraction of the expected words that were recognised, 0..1. */
  wordAccuracy: number
  /** Fraction of the expected phrase attempted at all, 0..1. */
  completeness: number
  /** Word-by-word comparison, for highlighting. */
  diff: WordDiffEntry[]
  passed: boolean
  message: string
}

export interface SpeakingAttemptResult {
  attemptId: string
  expectedText: string
  feedback: SpeakingFeedback
  /** Clip id of her own recording, so she can play it back. */
  recordingMediaId: string
  xpEarned: number
}

/** Upload limits, shared so the client can refuse before spending the network. */
export const SPEAKING_MAX_BYTES = 5 * 1024 * 1024
export const SPEAKING_MAX_SECONDS = 30

export const SPEAKING_CONTENT_TYPES = [
  'audio/webm',
  'audio/mp4',
  'audio/mpeg',
  'audio/ogg',
  'audio/wav',
] as const

export type SpeakingContentType = (typeof SPEAKING_CONTENT_TYPES)[number]
